<template>
  <b-card
    :class="`btn p-0 bg-${info.variant} text-white`"
    @click="$emit('editClick')"
  >
    <div class="d-flex align-items-center text-left">
      <div class="mr-1">
        <feather-icon
          size="36"
          :icon="info.icon"
        />
      </div>
      <div>
        <h4
          class="text-primary mb-0"
        >{{ $t(info.title) }}</h4>
        <p class="text-white mb-0">
          <!-- {{$t('objects.filling')}} {{ info.percent }}% -->
        </p>
      </div>
    </div>
    <b-button
      v-if="info.file_upload"
      variant="primary"
      class="bg-white"
      size="sm"
      @click="$emit('fileUploadClick')"
    >
      {{ $t('objects.update_from_file') }}
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BButton,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'ObjectCard',
  components: {
    BCard,
    FeatherIcon,
    BButton,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  methods: {
    buttonClick() {
      this.$emit('click')
    },
  },
}
</script>

<style>

</style>
